<template>
  <div>
    <div v-show="currentStep === 1" class="ls-application-review-item">
      <h4>Are you enjoying {{ brandName }}?</h4>
      <p></p>
      <div>
        <LsButton
          text="not really"
          bg-color="primary-light"
          track-id="ls_app_review-not_really"
          test-id="ls_app_review-not_really"
          @click="dismiss()"
        />
        <LsButton
          text="yes"
          bg-color="primary"
          track-id="ls_app_review-yes"
          test-id="ls_app_review-yes"
          @click="advanceStep()"
        />
      </div>
    </div>
    <div v-show="currentStep === 2" class="ls-application-review-item">
      <h4>How was your experience?</h4>
      <p>
        Thanks for choosing {{ brandName }}! Would you take a moment to leave us a review? Your
        feedback is highly appreciated and your responses will help us serve you better the future.
      </p>
      <div>
        <LsButton
          text="no thanks"
          bg-color="primary-light"
          track-id="ls_app_review-no_thanks"
          test-id="ls_app_review-no_thanks"
          @click="dismiss()"
        />
        <LsButton
          text="review us"
          bg-color="primary"
          track-id="ls_app_review-review_us"
          test-id="ls_app_review-review_us"
          @click="advanceStep()"
        />
      </div>
    </div>
    <div v-show="currentStep === 3" class="ls-application-review-item">
      <h4></h4>
      <p>
        We’re glad you’re enjoying {{ brandName }}! <br />
        <br />
        We look forward to continuing to provide you with excellent service.
      </p>
      <div>
        <LsButton
          text="dismiss"
          bg-color="primary"
          track-id="ls_app_review-dismiss"
          test-id="ls_app_review-dismiss"
          @click="dismiss()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { themedComponentMixin } from '@/mixins';
import { lsStorageService } from 'ls-vue-common';
import VueTypes from 'vue-types';

export default {
  name: 'ApplicationReview',
  components: {
    LsButton,
  },
  mixins: [themedComponentMixin],
  props: {
    reviewLink: VueTypes.string.isRequired,
  },
  data() {
    return {
      currentStep: 1,
    };
  },
  methods: {
    applicationReviewDismissed() {
      lsStorageService.set('APPLICATION_REVIEW_DISMISSED', true);
    },
    advanceStep() {
      if (this.currentStep === 2) {
        this.applicationReviewDismissed();
        window.open(this.reviewLink, '_blank');
      }

      this.currentStep++;
    },
    dismiss() {
      this.currentStep = 0;
      this.applicationReviewDismissed();
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-application-review-item {
  padding: 20px;
  margin-bottom: 20px;
  background: $primary-light;
  align-items: center;

  & > * {
    text-align: center;
    margin: 24px;
  }

  h4 {
    font-weight: bold;
  }

  button {
    border: 1px $primary solid;
    margin: 0 12px;
    @media (max-width: $mobile-max-width) {
      margin-top: 20px;
    }
  }
}

.themed-app {
  .ls-application-review-item {
    background: $theme-color-primary-light;
  }
}
</style>
